import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../../helpers/ApiCall';
import apiRoot from '../../consts/apiRoot';
import { FETCH_CONVERSATIONS, FETCH_CONVERSATIONS_SUCCESS, FETCH_CONVERSATIONS_FAIL } from '../../redux/Conversations';

function* fetchConversationsFlow() {
  try {
    const endpoint = `${apiRoot}/conversations`;
    const data = yield call(apiCall, { method: 'GET', endpoint, });
    yield put(FETCH_CONVERSATIONS_SUCCESS(data));
  } catch (error) {
    yield put(FETCH_CONVERSATIONS_FAIL(error));
  }
}

export default function* FetchConversations() {
  yield takeLatest(FETCH_CONVERSATIONS, fetchConversationsFlow);
}
